// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-Light.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-LightItalic.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-Regular.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-Italic.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-Medium.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-MediumItalic.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-SemiBold.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 600;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-SemiBoldItalic.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-Bold.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-BoldItalic.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-ExtraBold.ttf") format("truetype");
}

@font-face {
  font-family: "Open Sans";
  font-style: italic;
  font-weight: 800;
  font-display: swap;
  src: url("/static/fonts/open-sans/OpenSans-ExtraBoldItalic.ttf") format("truetype");
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/fonts.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yEAAyE;AAC3E;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,+EAA+E;AACjF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,2EAA2E;AAC7E;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gFAAgF;AAClF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kFAAkF;AACpF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mFAAmF;AACrF","sourcesContent":["@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-Light.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: italic;\n  font-weight: 300;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-LightItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-Italic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-Medium.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: italic;\n  font-weight: 500;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-MediumItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-SemiBold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: italic;\n  font-weight: 600;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-SemiBoldItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-Bold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-BoldItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 800;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-ExtraBold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: italic;\n  font-weight: 800;\n  font-display: swap;\n  src: url(\"/static/fonts/open-sans/OpenSans-ExtraBoldItalic.ttf\") format(\"truetype\");\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
